import fractToDec from "../../math/fractToDec.js";

/***
 * Returns new node id
 * @returns {`${number}:${number}`|`${number}`}
 */
export default () => {
    return `${(new Date()).getTime()}:${fractToDec(Math.random())}`;
}